module.exports = __webpack_public_path__ + "static/media/chests_bronze.1b492f25.png";